export const CONFIG_KEY = 'config';
export const THEME_KEY = 'activityTheme';
export const THEME_PAYLOAD_KEY = 'themePayload';
export const THEME_VARIANT_KEYS = ['themePayload', 'themeVariants'];
export const ASSETS = ['assets'];
export const ANCESTORS_KEY = 'ancestors';

export const INGESTION_CHANGE = 'ingestionChange';
export const config = [CONFIG_KEY];
export const theme = [THEME_KEY];
export const components = ['components'];
export const pluginRef = ['plugin'];
export const childrenPathwaysWithStatus = ['childrenPathwaysWithStatus'];

export const pluginConfigs = 'pluginConfigs';
export const elementValue = 'value';
export const guardRailsOptions = 'guardRailsOptions';
